import useViewer from './useViewer';

export default function useRequiresPaymentInformation() {
  const { viewer } = useViewer();

  return !!viewer.organization?.requiresPaymentInformation;
}
